module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: [_vm.decorated.day, _vm.decorated.status_text === 'Cancelled' ? 'load-cancelled' : '']
  }, [_c('div', {
    staticClass: "move-margin"
  }, [_c('p', {
    staticClass: "load-number"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(" "), _c('p', {
    staticClass: "load-reference"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'loads.show',
        params: {
          id: _vm.load.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.load.reference_number))]), _vm._v(" "), _c('span', {
    staticClass: "load-status pull-right",
    class: _vm.decorated.status_class
  }, [_vm._v(_vm._s(_vm.decorated.status_text))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Loading Date")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.loading_date) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Loading Time")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.loading_time) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Delivery Date")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.delivery_date) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Delivery Time")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.delivery_time) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Load Size")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.size) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Net Weight")]), _c('br'), _vm._v("\n\n          " + _vm._s(_vm.decorated.net_weight) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("\n            Rate\n            "), _c('span', {
    class: {
      'text-success': _vm.isProfitableLoadForArrow, 'text-danger': _vm.isNotProfitableLoadForArrow
    },
    attrs: {
      "title": _vm.perTonneDifference
    }
  }, [_vm._v("\n              " + _vm._s(_vm.arrowProfitAsMoney) + "\n            ")])]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.rate) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', {
    staticClass: "load-cost"
  }, [_c('strong', [_vm._v("Client Charge")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.clientChargeAsMoney) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-8 col-lg-6 col-xl-4"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Carrier")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.company) + "\n\n          "), (_vm.load.carrier) ? _c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": {
        name: 'users.edit',
        params: {
          id: _vm.load.carrier.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Rego")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.registration) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Driver")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.driver_name) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Configuration")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.configuration_description) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-4"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Weighbridge Details")]), _c('br'), _vm._v(" "), (_vm.haveWeighbridge) ? _c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-load-check"
    },
    on: {
      "click": _vm.setActiveLoad
    }
  }, [_vm._v("\n            View "), _c('i', {
    staticClass: "fa fa-external-link-square"
  })]) : _c('span', [_vm._v("–")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 driver-notes-col"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Driver Notes")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.load.notes) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-lg-2"
  }, [_c('p', {
    staticClass: "material-details truncate"
  }, [_c('strong', [_vm._v("Dockets")]), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dockets ? _vm.dockets : '–')
    }
  })])])]), _vm._v(" "), (_vm.haveCharges) ? _c('hr', {
    staticClass: "m-t-sm m-b-sm"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.load.charges), function(charge) {
    return _c('charge', {
      key: charge.id,
      attrs: {
        "charge": charge,
        "load": _vm.load
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3f801ddc"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/loads/AdminLoad.vue
// module id = 975
// module chunks = 0